import { LoadCssResolver, LoadScriptResolver, PrinterDataResolver } from '@b2b/common/resolvers';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { ProgramsInstanceEditControllerModule } from './controllers/ProgramsInstanceEditController';

export const ProgramsInstanceEditView = angular
  .module('acme.view.application.programs.instance.edit', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    ProgramsInstanceEditControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.programsInstanceEdit',
      url: '/programs/instance/:id/edit',
      views: {
        'subview-main': {
          controller: 'ProgramsInstanceEditController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/programs/instance/edit/edit.tpl.html',
        },
      },
      data: {
        pageTitle: 'Edit Event',
        permissions: ['EVENT_UPDATE', 'EVENT_DELETE'],
      },
      resolve: {
        bootstrap: LoadScriptResolver({ id: 'bootstrap-js', url: '/assets/bootstrap.min.js' }),
        summernote: LoadScriptResolver({ id: 'summernote-js', url: '/assets/summernote.min.js' }),
        summernoteCss: LoadCssResolver({ id: 'summernote', url: '/assets/summernote.css' }),
        selectizeCSS: LoadCssResolver({ id: 'selectize-css', url: '/assets/selectize.bootstrap3.css' }),
        PrinterData: PrinterDataResolver(),
      },
    });
  }).name;
